module.exports = __webpack_public_path__ + "static/media/22ESCWA14.4a86fc8f.jpg";